/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Finals_TableInputs */



/**
* | output |
* | --- |
* | "Finals Table" |
*
* @param {Tournament_Finals_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_finals_table = /** @type {((inputs?: Tournament_Finals_TableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Finals_TableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Table de finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mesa de finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mesa Final")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tavolo Finale")
	return /** @type {LocalizedString} */ ("Finals Table")
});